import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Paper } from "@material-ui/core";
import FileBase from "react-file-base64";
import { useDispatch, useSelector } from "react-redux";
import { createPost, updatePost } from "./../../actions/posts";

import useStyles from "./styles";

const Form = ({ currentId, setCurrentId }) =>
{

  //Setting progress to finished by default as it's going to be the most common by far
  const [mal_post_data, setPostData] = useState({ title: "", rating: "", image: "", progress: "Finished", comment: "" });
  const post = useSelector((state) => currentId ? state.posts.find((post) => post._id === currentId) : null);

  const classes = useStyles();
  const dispatch = useDispatch();


  useEffect(() =>
  {
    if (post) setPostData(post);
  }, [post])


  const HandleSubmit = (evt) =>
  {
    evt.preventDefault();
    if (currentId)
    {
      dispatch(updatePost(currentId, mal_post_data));
    }
    else
    {
      dispatch(createPost(mal_post_data));
    }

    clear();
  }

  const clear = () =>
  {
    setCurrentId(null);
    setPostData({ title: "", rating: "", image: "", progress: "Finished", comment: "" });
  }

  return (
    <div>
      <Paper className={classes.paper}>
        <form className={classes.root_form} onSubmit={HandleSubmit}>
          {!currentId ? (<Typography variant="h6">Post</Typography>) : (<Typography variant="h6">Update</Typography>)}
          <TextField className={classes.text_field} name="title" variant="outlined" label="Title" fullWidth value={mal_post_data.title} onChange={(evt) => setPostData({ ...mal_post_data, title: evt.target.value })} />
          <TextField className={classes.text_field} name="rating" variant="outlined" label="Rating" fullWidth value={mal_post_data.rating} onChange={(evt) => setPostData({ ...mal_post_data, rating: evt.target.value })} />
          <TextField inputProps={{ maxLength: 2000 }} className={classes.text_field} name="comment" variant="outlined" label="Comment" fullWidth value={mal_post_data.comment} onChange={(evt) => setPostData({ ...mal_post_data, comment: evt.target.value })} />
          <select className={classes.select} name="progress" onChange={(evt) => setPostData({ ...mal_post_data, progress: evt.target.value })}>
            <option value="Finished">Finished</option>
            <option value="Ongoing">Ongoing</option>
            <option value="Dropped">Dropped</option>
          </select>
          <div className={classes.file_input_wrapper}>
            <FileBase className={classes.file_input} type="file" multiple={false} onDone={(image_data) => setPostData({ ...mal_post_data, image: image_data })} />
          </div>
          <Button className={classes.submit_btn} variant="contained" color="primary" size="large" type="submit" fullWidth >Submit</Button>
        </form>
      </Paper>
    </div>
  );
}


export default Form;

